import styled, { withTheme } from 'styled-components';

const TextDark = styled.span`
    color: ${props => props.theme.$dark};

`;

export default withTheme(TextDark);
